import { SchedulesListCategory } from '@app/modules/audit/modules/station-audit/components/audit-result/build-schedules-list-order-filter-url';
import { AuditAudioInMatch, AuditSchedule, DateTimeStr } from '@mi-front/core';
import {
  getMentionMatchPlaybackRange,
  getSpotMatchPlaybackRange,
  VerifyMatchPlaybackRange,
} from './verify-match-range';
import { VerifyMatchTarget } from './verify-match-types';

/**
 * Detection datetime shown in the dialog title and logger link.
 */
export function getVerifyMatchDatetime(target: VerifyMatchTarget): DateTimeStr {
  return target.kind === 'spot' ? target.match.datetime : target.mention.datetime;
}

/**
 * Material / mention identifier shown in the dialog title.
 */
export function getVerifyMatchMaterialId(target: VerifyMatchTarget): string | null {
  if (target.kind === 'spot') {
    return target.match.audio?.customId ?? null;
  }

  return target.mention.name || null;
}

/**
 * Logger stream tab for the “show on stream” action.
 */
export function getVerifyMatchLoggerTab(
  target: VerifyMatchTarget,
): 'audiomatches' | 'livementions' {
  return target.kind === 'spot' ? 'audiomatches' : 'livementions';
}

/**
 * Schedule linked to the detection (matched or confirmed).
 */
export function getVerifyMatchLinkedSchedule(
  target: VerifyMatchTarget,
): AuditSchedule | null | undefined {
  return target.kind === 'spot' ? target.match.matchedSchedule : target.mention.confirmedSchedule;
}

/**
 * Schedules-list category used for order filter deep links.
 */
export function getVerifyMatchSchedulesListCategory(
  target: VerifyMatchTarget,
): SchedulesListCategory {
  return target.kind === 'spot' ? 'spot' : 'mentions';
}

/**
 * Broadcast playback window for the current target.
 */
export function getVerifyMatchPlaybackRange(target: VerifyMatchTarget): VerifyMatchPlaybackRange {
  return target.kind === 'spot'
    ? getSpotMatchPlaybackRange(target.match)
    : getMentionMatchPlaybackRange(target.mention);
}

/**
 * Reference creative audio for spot matches; null for mentions.
 */
export function getVerifyMatchCreativeAudio(
  target: VerifyMatchTarget,
): AuditAudioInMatch | null | undefined {
  return target.kind === 'spot' ? target.match.audio : null;
}

/**
 * Duration passed to the logger link (spot audio/played duration, or mention range length).
 */
export function getVerifyMatchBroadcastDurationMs(
  target: VerifyMatchTarget,
  range: VerifyMatchPlaybackRange,
): number {
  if (target.kind === 'spot') {
    return target.match.audio?.duration ?? target.match.playedDuration;
  }

  return range.to - range.from;
}
